'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _elementHelper = require('../../../../common/elements/elementHelper');

exports.default = function (_ref) {
    var props = _ref.props,
        monitor = _ref.monitor;

    var item = monitor.getItem();
    var element = props.element;

    // Don't allow columns to be dropped on columns

    return !element || !item.element || !((0, _elementHelper.isColumn)(element) && item.draggedElements.every(function (el) {
        return (0, _elementHelper.isColumn)(el) || (0, _elementHelper.isLine)(el);
    }));
}; // Utils


//////////////////
// WEBPACK FOOTER
// ./src/client/element/dnd/canDrop/preventColumnsOrLinesOnColumnsPredicate.js
// module id = 1974
// module chunks = 0